<breadcrumb-layout>
	<breadcrumb-item-view (action)="goToSettings()">
		{{ 'header_account-settings' | translate }}
	</breadcrumb-item-view>
</breadcrumb-layout>
